import { ErrorObject } from '@qpr/client-library/dist/esm/ErrorContext';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { useQuery } from 'react-query';

export interface Range {
  name: string;
  maxseriesid: string;
  maxbelongstorange: string;
  minseriesid: string;
  minbelongstorange: string;
  rangevalue: string;
  color: string;
  disabled?: boolean;
}

export const useRanges = (
  meaId: string | undefined,
  recursive: boolean = false,
  recursionCount: number = 0
) =>
  useQuery<AxiosResponse<Range[]>, AxiosError<ErrorObject>>(
    `ranges-${meaId}`,
    async () => {
      const response = await axios.post('meaquery', {
        // should it be 'subobjects' or 'childobjects'? Both seem to work, but 'subobjects' also works with onlyt model id given.
        query: `[${meaId}].subobjects(recursive=${
          recursive ? '1' : '0'
        }, keeporiginals=1, recursionCount=${
          recursionCount || '0'
        }).attributeasfunction(attributeasfunction="valuesettingid").ranges`,
        attributes:
          'name, maxseriesid, maxbelongstorange, minseriesid, minbelongstorange, rangevalue, color, valuesettings',
        sortBy: 'rangeValue'
      });

      return response.data;
    },
    {
      enabled: !!meaId,
      staleTime: 60 * 1000
    }
  );

export default useRanges;
